import { request } from '!core/api';
import { isTokenExpired } from '»utils/jwt';

export const loadState = () => {
  try {
    const stateString = sessionStorage.getItem('state');
    if (stateString === null) {
      return undefined;
    }
    const stateObject = JSON.parse(stateString);

    if (!isTokenExpired(stateObject.auth.token)) {
      const { user, token } = stateObject.auth;
      request.setAuth(user, token);
      return stateObject;
    }

    return {
      error: {
        title: 'Token has expired.',
        status: 'internal',
        detail: 'Token has expired.',
      },
    };
  } catch {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    if (!state.auth.isAuthenticated) {
      sessionStorage.removeItem('state');

      return null;
    }

    const serializedState = JSON.stringify(state);
    sessionStorage.setItem('state', serializedState);
  } catch (error) {
    console.error(
      '%c store saveState error ->',
      'background: #222; color: #0071ce',
      error,
    );
  }
  return null;
};
